import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Image } from "../../image/image.mjs";
const HeaderMegamenuBanner = (props) => {
  const { background, image, children, className, ...rest } = props;
  const BEM = () => {
    const classArray = ["header__megamenu-banner"];
    if (background) {
      classArray.push("header__megamenu-banner--with-background");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const renderImageGrid = () => {
    return /* @__PURE__ */ React.createElement(Grid, { noWrap: true, align: ["middle-xs"] }, image && /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(Image, { ...image })), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, children));
  };
  return /* @__PURE__ */ React.createElement(Anchor, { isUnderlined: false, ...rest, className: BEM() }, /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-banner-inner" }, /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-banner-content" }, image ? renderImageGrid() : children), background && /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-banner-background" }, /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-banner-background-inner" }, /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-banner-background-image-wrapper" }, /* @__PURE__ */ React.createElement(Image, { ...background, className: "header__megamenu-banner-background-image" }))))));
};
export {
  HeaderMegamenuBanner
};
